/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

/**
 * Contract side
 */
export type PlaceOrderDtoSide = (typeof PlaceOrderDtoSide)[keyof typeof PlaceOrderDtoSide];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaceOrderDtoSide = {
  yes: 'yes',
  no: 'no',
} as const;
